import React from 'react'
const Footer=()=>{
    return(
        <div className="container-fluid">
            <h6 className="text-center">Build and Design by Pradeep Gautam</h6>
        </div>
    )
}
export default Footer